import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import PrintForm from '../forms/print-form';
import { printValidationSchema } from '../schema/print.js';

export default function PrintNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Print Node Details',
        altText: 'Print Node',
        defaultLabel: data?.command || 'Print Node',
        forceDefaultLabel: true,
      }}
    >
      <CommonNode FormComponent={PrintForm} schemaResolver={printValidationSchema} />
    </NodeProvider>
  );
}
